import { INTERACTION_TYPES, ShellStore } from '@vfmfe/foundations';
import { getUserInfo } from '../api';
import { clearAuthentication, CurrentLoggedUser, setCurrentLoggedUser } from '../redux/reducers/authorization';
import { closeInteraction } from '../redux/reducers/interactions';
import { UserInfo } from '../types/authorization';
import { recontextInteraction } from './interaction';

export const mapUserInfoToCurrentLoggedUser: (userInfo: UserInfo) => CurrentLoggedUser = (userInfo: UserInfo) => {
    return {
        email: userInfo.user_info?.email || '',
        firstName: userInfo.user_info?.name?.split(' ')[0],
        lastName: userInfo.user_info?.name?.split(' ')[1],
        id: userInfo.sub,
        username: userInfo.user_info?.email || ''
    };
};

export const getDataForContextualizationFromUserInfo = (userInfo: UserInfo) => {
    const billingAccountIdToContextualize = userInfo.user_info.userAssets?.find(
        (userAsset) => userAsset.assetType === 'BillingAccount'
    )?.id;
    return { type: INTERACTION_TYPES.BILLING_ACCOUNT, id: billingAccountIdToContextualize };
};

export const getUserInfoIfNotAnon = async () => {
    const getUserInfoRes = await getUserInfo();
    if (!getUserInfoRes.data) {
        throw new Error('User info response does not contain data');
    }

    if (getUserInfoRes?.data?.issued_token_type === 'client_credentials') {
        return;
    }
    return getUserInfoRes?.data;
};

export const getUserInfoAndContextualize = async (store: ShellStore) => {
    const userInfo = await getUserInfoIfNotAnon();

    if (!userInfo) {
        //ANON
        store.dispatch(clearAuthentication());
        store.dispatch(closeInteraction());
        return;
    }

    const dataForContextualization = getDataForContextualizationFromUserInfo(userInfo);
    if (!dataForContextualization.id || !dataForContextualization.type) {
        throw new Error('No billing account found for contextualization');
    }
    try {
        await recontextInteraction({
            type: dataForContextualization.type,
            identifier: dataForContextualization.id,
            store
        });
        const fullNameFromInteraction = store.getState().interactions.currentInteraction.context.individual?.fullName;

        userInfo.user_info.name = userInfo.user_info.name ?? fullNameFromInteraction;

        const mappedUserInfo = mapUserInfoToCurrentLoggedUser(userInfo);

        store.dispatch(setCurrentLoggedUser(mappedUserInfo));
    } catch (error) {
        console.error('Error during contextualization:', error);
        throw error;
    }
};
